module.exports = __webpack_public_path__ + "4702a1072ca6ed0c641107a56ef2e713.jpg";